import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel, Tooltip,
  Paper,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FilterPopupTeam from "./FilterPopupTeam";
import Dublicate from "../../../src/assests/images/dublicate-icon.svg";
import MessengerIcon from "../../../src/assests/images/MessengerIcon.svg";
import edit from "../../../src/assests/images/edit.svg";
import PaginationComponent from "../../pages/brands/Pagination";
import { useNavigate } from "react-router-dom";
import SortingArrow from "../../../src/assests/images/Sorting.svg";
import { profiledata } from "./api";
import { getToken } from "../../utils/utils";

interface RowData {
  id: number;
  memberName: string;
  teams: string;
  moduleOwner: string;
  createdDate: string;
  moduleAccessAssigned: string;
  profile_request?: string;
  req_desc?: string;
  status: boolean
  mainroles: number
}

interface Filters {
  [key: string]: {
    [key: string]: {
      checked: boolean;
      id: number;
    };
  };
}

interface TeamTableProps {
  totalcount: number;
  data: any[];
  page: number;
  limit: number;
  totalPages: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  applyFilters: () => void;
  filters: Filters;
  setFilters: React.Dispatch<React.SetStateAction<Filters>>;
  selectedDate: Date | null;
  setSelectedDate: React.Dispatch<React.SetStateAction<Date | null>>;
  applydetailes: boolean;
  setapply: (value: boolean) => void;
  selectedTab1: number;
  setSelectedTab1: React.Dispatch<React.SetStateAction<number>>;
  selectedRows22: RowData[];
  setSelectedRows22: React.Dispatch<React.SetStateAction<RowData[]>>;
}

const TeamTable: React.FC<TeamTableProps> = ({
  totalcount,
  data,
  page,
  limit,
  totalPages,
  setPage,
  applyFilters,
  filters,
  setFilters,
  selectedDate,
  setSelectedDate,
  applydetailes,
  setapply,
  selectedTab1,
  setSelectedTab1,
  selectedRows22,
  setSelectedRows22,
}) => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [order, setOrder] = useState<"asc" | "desc">("asc");
  const [orderBy, setOrderBy] = useState<keyof RowData | "">("");
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [reqDescMap, setReqDescMap] = useState<Record<number, string | undefined>>({});
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const popupRef = useRef<HTMLDivElement | null>(null);
  const navigate = useNavigate();
  const token = getToken();

  const togglePopup = () => setIsPopupVisible(!isPopupVisible);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(event.target as Node) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target as Node)
      ) {
        setIsPopupVisible(false);
      }
    };

    if (isPopupVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPopupVisible]);
  console.log(data, "datadatadatadatadatadata2222222222")
  // Fetch req_desc from profiledata API for current page only
  useEffect(() => {
    const fetchReqDesc = async () => {
      // if (!data || data.length === 0) {
      //   console.log("No data available to fetch req_desc");
      //   return;
      // }
      try {
        const newReqDescMap: Record<number, string | undefined> = { ...reqDescMap };
        // Fetch only for visible rows (based on pagination)
        const startIndex = (page - 1) * limit;
        const endIndex = Math.min(startIndex + limit, data.length);
        const visibleRows = data.slice(startIndex, endIndex);

        for (const row of visibleRows) {
          if (row.id && !newReqDescMap[row.id]) {
            console.log(`Fetching profiledata for member ID: ${row.id}`); // Debug log
            try {
              const response = await profiledata({ id: String(row.id) }, token);
              console.log(`Profiledata response for ID ${row.id}:`, response); // Debug log
              const reqDesc = response?.data?.data?.[0]?.req_desc || "";
              newReqDescMap[row.id] = reqDesc;
            } catch (error) {
              console.error(`Failed to fetch req_desc for member ${row.id}:`, error);
              newReqDescMap[row.id] = undefined;
            }
          }
        }
        console.log("Updated reqDescMap:", newReqDescMap); // Debug log
        setReqDescMap(newReqDescMap);
      } catch (error) {
        console.error("Error fetching req_desc data:", error);
      }
    };

    fetchReqDesc();
  }, [page, limit, token]);

  const handleSort = (property: keyof RowData) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const mapRowData = (row: any): RowData => {
    const reqDesc = reqDescMap[row.id];
    console.log("Mapping row:", row, "req_desc:", reqDesc); // Debug log
    return {
      id: row.id,
      memberName: row.member_name || "",
      teams: row.teams?.map((team: any) => team.team_name).join(", ") || "",
      moduleOwner: row.modulenammain || "",
      createdDate: row.created_at || "",
      moduleAccessAssigned: row.modules?.map((module: any) => module.module_name).join(", ") || "",
      profile_request: row.profile_request || "",
      req_desc: reqDesc,
      status: row.status,
      mainroles: row.mainroles
    };
  };

  const rows: RowData[] = data.map(mapRowData);
  console.log("Rows with req_desc:", rows); // Debug log

  const sortedRows = [...rows].sort((a, b) => {
    if (!orderBy) return 0;

    const aVal = a[orderBy];
    const bVal = b[orderBy];

    if (typeof aVal === "string" && typeof bVal === "string") {
      return order === "asc" ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
    } else if (typeof aVal === "number" && typeof bVal === "number") {
      return order === "asc" ? aVal - bVal : bVal - aVal;
    }
    return 0;
  });

  const handleEdit = (id: number) => {
    navigate(`/team-Members/edit-team-form/${id}`);
  };

  const handleMessenger = (id: number) => {
    navigate(`/team-Members/edit-team-form/${id}?source=messenger`);
  };

  const handleDuplicate = (id: number, mainroles: number) => {
    console.log(mainroles, "ssss44444444444444");
    const rowToDuplicate = sortedRows.find((row) => row.id === id);

    if (rowToDuplicate) {
      setSelectedRows22([rowToDuplicate]);

      let path = '';

      if (mainroles === 3) {
        path = `/team-Members/team-form/${id}`;
      } else if (mainroles === 2) {
        path = `/team-Members/module-owner-form/${id}`;
      } else {
        console.warn('Unknown main role, no navigation performed.');
        return;
      }

      navigate(path, {
        state: {
          duplicateData: {
            memberName: `${rowToDuplicate.memberName} (copy)`,
            teams: rowToDuplicate.teams,
            moduleOwner: rowToDuplicate.moduleOwner,
            moduleAccessAssigned: rowToDuplicate.moduleAccessAssigned,
          },
        },
      });
    }
  };

  console.log(selectedTab1, "srttttttttttttttttt")
  console.log(sortedRows, "sortedRows sortedRows sortedRows sortedRows")
  return (
    <Box sx={{ background: "#F9FBFC", paddingTop: "50px", borderTop: "1px solid #E7E8E9" }}>
      <Box sx={{ padding: "0 32px", marginBottom: "30px" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            background: "#fff",
            border: "1px solid #E4E7EC",
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
          }}
        >
          <Typography
            variant="h3"
            sx={{
              fontSize: "18px",
              color: "#282829",
              fontWeight: "600",
              padding: "20px",
              background: "#fff",
              borderTopLeftRadius: "10px",
              borderTopRightRadius: "10px",
            }}
          >
            Total {totalcount} Members
          </Typography>
          <Box>
            <Button
              ref={buttonRef}
              variant="contained"
              onClick={togglePopup}
              sx={{
                textTransform: "capitalize",
                backgroundColor: "#fff",
                height: "44px",
                padding: "3px 12px",
                borderRadius: "10px",
                color: "#565656",
                border: "1px solid #DEDEDE",
                boxShadow: "none",
                // marginRight: "20px",
                margin: "20px 20px",
                "&:hover": { backgroundColor: "#fff" },
              }}
              endIcon={<ExpandMoreIcon sx={{ fontSize: "30px" }} />}
            >
              Filters
            </Button>

            {isPopupVisible && (
              <div ref={popupRef}>
                <FilterPopupTeam
                  filter={{ onClose: () => setIsPopupVisible(false) }}
                  selectedDate={selectedDate}
                  applyFilters={applyFilters}
                  filters={filters}
                  setFilters={setFilters}
                  applydetailes={applydetailes}
                  setapply={setapply}
                  selectedTab1={selectedTab1}
                  setSelectedTab1={setSelectedTab1}
                  setSelectedDate={setSelectedDate}
                  selectedTab={0}
                  setSelectedTab={() => {
                    throw new Error("Function not implemented.");
                  }}
                />
              </div>
            )}
          </Box>
        </Box>

        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="sortable table">
            <TableHead sx={{ background: "#EEF4FF" }}>
              <TableRow>
                {[
                  { label: "Member Name", key: "memberName" },
                  { label: "Teams", key: "teams" },
                  { label: "Module Owner", key: "moduleOwner" },
                  { label: "Created Date", key: "createdDate" },
                  { label: "Module Access Assigned", key: "moduleAccessAssigned" },
                  { label: "Actions", key: "action" },
                ].map((col) => (
                  <TableCell key={col.key}>
                    {col.key === "action" ? (
                      // Render plain text without sorting
                      <Typography variant="subtitle2">{col.label}</Typography>
                    ) : (
                      <TableSortLabel
                        active={orderBy === col.key}
                        direction={orderBy === col.key ? order : "asc"}
                        onClick={() => handleSort(col.key as keyof RowData)}
                        IconComponent={() =>
                          col.key === "action" ? (
                            <></>
                          ) : (
                            <img
                              src={SortingArrow}
                              alt="Sort Icon"
                              style={{ width: 18, height: 18, marginLeft: 4 }}
                            />
                          )
                        }
                        sx={{
                          "& .MuiTableSortLabel-icon": {
                            opacity: 1,
                          },
                        }}
                      >
                        {col.label}
                      </TableSortLabel>
                    )}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {sortedRows.map((row, index) => (
                <TableRow
                  key={row.id}
                  sx={{
                    "&:hover .hover": { visibility: "visible" },
                    backgroundColor: index % 2 !== 0 ? "#F9FBFC" : "transparent",
                  }}
                >
                  <TableCell>{row.memberName}</TableCell>
                  <TableCell>{row.teams}</TableCell>
                  <TableCell sx={{ width: "200px" }}>
                    <Tooltip
                      title={row.moduleOwner && row.moduleOwner.length > 0 ? row.moduleOwner : ""}
                      arrow
                      placement="top"
                      disableHoverListener={!row.moduleOwner}
                      PopperProps={{
                        modifiers: [
                          {
                            name: "offset",
                            options: {
                              offset: [0, 8],
                            },
                          },
                        ],
                        sx: {
                          "& .MuiTooltip-tooltip": {
                            maxWidth: "600px",
                            whiteSpace: "normal",
                            fontSize: "14px",
                          },
                        },
                      }}
                    >
                      <Box
                        sx={{
                          maxHeight: "40px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          whiteSpace: "normal",
                          cursor: "pointer",
                        }}
                      >
                        <Typography variant="body2">
                          {row.moduleOwner?.length > 100
                            ? `${row.moduleOwner.slice(0, 100)}...`
                            : row.moduleOwner}
                        </Typography>
                      </Box>
                    </Tooltip>
                  </TableCell>
                  <TableCell
                    sx={{
                      color:
                        typeof row.createdDate === "string" &&
                          row.createdDate.toLowerCase().includes("expiring")
                          ? "#F7363C !important"
                          : "inherit",
                    }}
                  >
                    {row.createdDate}
                  </TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        width: "200px",
                      }}
                    >
                      {row.moduleAccessAssigned}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box
                      className="hover"
                      sx={{ display: "flex", gap: 1, width: "100px" }}
                    >
                      <Box>
                        {row.profile_request ? (
                          <img
                            src={MessengerIcon}
                            alt="Messenger Icon"
                            style={{
                              cursor: "pointer",
                              width: "23px",
                              marginRight: "6px",
                            }}
                            onClick={() => handleMessenger(row.id)}
                          />
                        ) : null}

                        <a
                          href={
                            row.mainroles === 3
                              ? `/team-Members/team-form/${row.id}`
                              : row.mainroles === 2
                                ? `/team-Members/module-owner-form/${row.id}`
                                : '#'
                          }
                          onClick={(e) => {
                            e.preventDefault();
                            handleDuplicate(row.id, row.mainroles);
                          }}
                        >
                          <img
                            src={Dublicate}
                            alt="Duplicate Icon"
                            style={{ cursor: "pointer", width: "23px" }}
                          />
                        </a>
                      </Box>
                      <img
                        src={edit}
                        alt="Edit"
                        style={{ cursor: "pointer", width: "23px" }}
                        onClick={() => handleEdit(row.id)}
                      />
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Box
          sx={{
            background: "#fff",
            padding: "10px 0",
            border: "1px solid #ededed",
            borderTop: "0",
            borderBottomLeftRadius: "10px",
            borderBottomRightRadius: "10px",
            boxShadow: "-1px 1px 1px 0px #e0e0e0"
          }}
        >
          <PaginationComponent
            page={page}
            limit={limit}
            totalPages={totalPages}
            setPage={setPage}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default TeamTable;